module.exports = __webpack_public_path__ + "static/juvederm.6bd7e249.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/partners/juvederm.png
// module id = 614
// module chunks = 114276838955818